// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"eH50g1","childrenWrapperDirection":"fr3A7J"};